import { Loader } from '@googlemaps/js-api-loader';

const loader = new Loader({
    apiKey: 'AIzaSyAPu7Rl-tLBPJbtAt6AqJK9QHulEwDD6Wg',
    version: 'weekly'
});

const initMaps = (element) => {
    loader.load().then(async () => {
        const { Map } = await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

        // Get zoom data attr
        const zoom = parseFloat(element.dataset.zoom);

        // Get lat and lng data attrs
        const { lat } = element.dataset;
        const { lng } = element.dataset;

        const latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };

        // Create gerenic map
        const mapArgs = {
            zoom: zoom || 16,
            center: latLng,
            mapId: '353b6fa2d58c8d9db0b8f07c',
            disableDefaultUI: true
        };

        const map = new Map(element, mapArgs);

        // Create icon object. themeUrl set in enqueue.php with wp_localize
        const imageUrl = new URL(
            '/img/marker.svg',
            import.meta.url
        );

        const icon = document.createElement('img');
        icon.width = 50;
        icon.height = 50;
        icon.src = imageUrl;

        // Create marker instance.
        const marker = new AdvancedMarkerElement({
            map,
            position: latLng,
            content: icon
        });

        marker.content.style.transform = 'translateY(50%)';

        setTimeout(() => {
            element.classList.add('loaded');
        }, 400);

        // Return map instance.
        return map;
    });
};

export { initMaps as default };
